import { Link } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";

const year = new Date().getFullYear();

export interface LandingFooterProps {
  /** Opens the same login flow as the header (recommended on landing). */
  onOpenLogin?: () => void;
}

/** Public landing footer with logo, cuenta links, and legal line. */
export function LandingFooter({ onOpenLogin }: LandingFooterProps) {
  return (
    <footer
      className="relative z-20 border-t border-border bg-gradient-to-b from-white to-slate-50/80"
      role="contentinfo"
    >
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
        <div className="grid gap-10 md:grid-cols-2 lg:gap-8">
          <div className="flex items-center">
            <img
              src={require("../../icons/Logo-Celmar.png")}
              alt="Celmar"
              className="h-9 w-auto sm:h-10"
            />
          </div>

          <div>
            <h3 className="mb-3 text-xs font-semibold uppercase tracking-wide text-foreground/80">
              Cuenta
            </h3>
            <ul className="space-y-2.5 text-sm text-muted-foreground">
              <li>
                {onOpenLogin ? (
                  <button
                    type="button"
                    onClick={onOpenLogin}
                    className="inline-flex items-center gap-2 font-medium text-[#205f43] transition hover:text-[#6CB7A2]"
                  >
                    <LogIn className="h-4 w-4" />
                    Iniciar sesión
                  </button>
                ) : (
                  <Link
                    to="/"
                    className="inline-flex items-center gap-2 font-medium text-[#205f43] transition hover:text-[#6CB7A2]"
                  >
                    <LogIn className="h-4 w-4" />
                    Iniciar sesión
                  </Link>
                )}
              </li>
              <li>
                <Link
                  to="/password-reset"
                  className="inline-flex items-center gap-2 transition hover:text-[#205f43]"
                >
                  <Lock className="h-4 w-4 shrink-0" />
                  Olvidé mi contraseña
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-border/80 pt-8">
          <p className="text-xs text-muted-foreground">
            © {year} Celmar. Todos los derechos reservados. El uso de la
            plataforma está sujeto a políticas y términos aplicables al
            colaborador registrado.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default LandingFooter;
